import React, { useState, useMemo } from 'react'
import DataTable from 'react-data-table-component';
import DownloadButton from './DownloadButton';
import FilterComponent from './FilterComponent';

const paginationComponentOptions = {
    noRowsPerPage: false,
    rowsPerPageText: 'Row per page',
    selectAllRowsItem: true,
    selectAllRowsItemText: 'All',
};

function OutputTable({ data, columns }) {
    const [filterText, setFilterText] = useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const filteredItems = data.filter(item =>
        (filterText === '') ||
        (item.NAME && item.NAME.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.NAME2 && item.NAME2.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.NAME3 && item.NAME3.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.NAME4 && item.NAME4.toLowerCase().includes(filterText.toLowerCase()))
    );

    const subHeaderComponentMemo = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText('');
            }
        };
        return (
            <FilterComponent onFilter={e => setFilterText(e.target.value)} onClear={handleClear} filterText={filterText} />
        );
    }, [filterText, resetPaginationToggle]);
    return (
        <div>
            <DataTable stickyHeader={true}
                columns={columns.map(column => ({
                    name: column,
                    selector: row => row[column],
                    sortable: true,
                    wrap: true
                }))}
                data={filteredItems}
                pagination
                paginationPerPage={6}
                paginationRowsPerPageOptions={[6, 10, 15, 20]}
                paginationComponentOptions={paginationComponentOptions}
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
            />
            <DownloadButton data={filteredItems} columns={columns} />
        </div>

    );
};

export default OutputTable;